/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { PROVIDER } from '@models/recognition';
import { AppConfigModel } from '@models/app/app-config.model';

export const APP_CONFIG: AppConfigModel = {
  theme: {},
  generic: {
    redirectUnauthorized: true
  },
  obligations: {
    explicitConfirmation: true
  },
  security: {
    urlOutOfAuth: [
      'assets/i18n',
      'assets/demo',
      'qinetic-security/api/authenticate'
    ]
  },
  wizard: {
    startPage: 'welcome',
    useQueryParam: false
  },
  survey: {},
  form: {},
  upload: {
    fileNameHeader: 'Content-Disposition',
    minHawkScore: 0.9,
    uploadSorting: [
      'DOC_IDE', // documenti d'identità
      'B03.1', // cartà identità
      'B03.2', // passaporto
      'B03.3', // patente
      'DI_AGG', // altri documenti d'identità
      'F22', // autocertificazione residenza
      'B05', // permesso di soggiorno
      'B04', // codice fiscale
      'DOC_RED', // documenti reddituali
      'B07', // busta paga
      'B94', // cedolino
      'DOC_RED_PENS', // Doc. reddituali pensionati
      'B09', // obis
      'B95', // obis
      'F06' // CUD
    ],
    checkSorting: [
      'B04', // codice fiscale
      'DOC_IDE', // documenti d'identità
      'B03.1', // cartà identità
      'B03.2', // passaporto
      'B03.3', // patente
      'DI_AGG', // altri documenti d'identità
      'F22', // autocertificazione residenza
      'B05', // permesso di soggiorno
      'DOC_RED', // documenti reddituali
      'B07', // busta paga
      'B94', // cedolino
      'DOC_RED_PENS', // Doc. reddituali pensionati
      'B09', // obis
      'B95', // obis
      'F06' // CUD
    ]
  },
  labels: {
    openLabelsUrl: './assets/i18n/open-labels.json'
  },
  recognition: {
    methodProviders: {
      ['VIDEOSELFIE']: PROVIDER.crif,
      ['SPID']: PROVIDER.namirial,
      ['CIE']: PROVIDER.namirial
    },
    maxAttemps: 3
  },
  documentsRequest: {
    additionalRequestOperationCodes: ['WEB_RIC_DOC']
  }
};
